import { graphql } from 'babel-plugin-relay/macro';
import {
  TranslationExerciseContentInput,
  UpdateTranslationExerciseMutation,
} from './__generated__/UpdateTranslationExerciseMutation.graphql';
import { commitMutationPromise } from '../lib/graphqlUtils';
import { updateExerciseUpdater } from './helpers/exerciseMutationHelpers';
const mutation = graphql`
  mutation UpdateTranslationExerciseMutation(
    $input: UpdateTranslationExerciseInput!
  ) {
    updateTranslationExercise(input: $input) {
      exercise {
        id
        content {
          prompt
          correctAnswers
          scrambledParts
        }
      }
    }
  }
`;
type fields = {
  content?: TranslationExerciseContentInput | null;
  position?: number | null;
};

const commit = (
  environment: any,
  id: string,
  worksheetId: string,
  fields: fields,
) =>
  commitMutationPromise<UpdateTranslationExerciseMutation>(environment, {
    mutation,
    variables: {
      input: {
        id,
        ...fields,
      },
    },
    optimisticUpdater: updateExerciseUpdater(
      'TranslationExercise',
      id,
      worksheetId,
      fields,
    ),
    updater: updateExerciseUpdater(
      'TranslationExercise',
      id,
      worksheetId,
      fields,
    ),
  });

export default {
  commit,
};
